export const RrpPriceTypes = [
  {
    value: 'standard',
    label: 'Стандартная',
  },
  {
    value: 'default',
    label: 'Со скидкой без карты',
    beta: true,
  },
  {
    value: 'card',
    label: 'Со скидкой с картой',
    beta: true,
  },
]

export const RrpPriceTypeHint =
  'Стандартная — цена, которую устанавливает продавец, без учёта скидок маркетплейса. ' +
  'Со скидкой без карты — серая цена на витрине. ' +
  'Со скидкой с картой — цена с Ozon Картой или WB Кошельком.'

export const RrpPriceTypeTrackingHint =
  'Для контроля РРЦ по цене со скидкой нужно включить отслеживание цен витрины для этих офферов и дождаться появления цен.'

export const SHOWCASE_PRICES_PATH = '/products?tab=showcase'

export const RrpPriceTypeLabels = Object.fromEntries(
  RrpPriceTypes.map(({ value, label }) => [value, label])
)

export function formatRrpPriceType(value) {
  if (value == null) return '—'
  return RrpPriceTypeLabels[value] || value
}

export function isRrpPriceTypeBeta(value) {
  return RrpPriceTypes.some((item) => item.value === value && item.beta)
}

export function formatRrpApplied(value) {
  if (value === true) return 'Да'
  if (value === false) return 'Нет'
  return '—'
}
